/**
 * @module roles
 */
import { createReducer } from '@reduxjs/toolkit';
import { userActions } from '~/behaviors/actions/user.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

/**
 * Iterate over each element of `action.payload.roles` and merge each with any
 * existing entity with the same ID in the state (or create new one if none exist).
 */
const mergeRoles = (state, action) => {
  const roles = action?.payload?.entities?.roles || {};

  Object.values(roles).forEach((role) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[role.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[role.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...role,
    };
  });
};

const deleteRole = (state, action) => {
  const id = action?.payload?.id;

  if (id) {
    const { [id]: _deletedRole, ...remainingRoles } = state;

    return remainingRoles;
  }
};

const roles = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(userActions.createRole.fulfilled, mergeRoles);
  builder.addCase(userActions.updateRole.fulfilled, mergeRoles);
  builder.addCase(userActions.deleteRole.fulfilled, deleteRole);
  builder.addCase(userActions.fetchRoles.fulfilled, mergeRoles);
  builder.addCase(userActions.fetchRole.fulfilled, mergeRoles);
});

export default roles;
